import React, { Component } from 'react';
import './OlderAdults.css';

class OlderAdults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: '',
        email: '',
        hcpLevel: '',
        provider: '',
        items: ''
      },
      stats: {
        independence: 0,
        painReduction: 0,
        satisfaction: 0
      }
    };
  }

  componentDidMount() {
    this.animateStats();
  }

  animateStats() {
    setTimeout(() => {
      this.setState({ stats: { independence: 85, painReduction: 80, satisfaction: 95 } });
    }, 500);
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! Your HCP invoice request has been submitted. Our team will contact you within 24 hours.');
    this.setState({
      formData: {
        name: '',
        email: '',
        hcpLevel: '',
        provider: '',
        items: ''
      }
    });
  };

  render() {
    const { stats, formData } = this.state;

    const benefits = [
      {
        icon: '🤝',
        title: 'Easy Dressing',
        description: 'Magnetic closures and open-back designs make dressing simple and pain-free.',
        color: '#4F46E5'
      },
      {
        icon: '💪',
        title: 'Maintain Independence',
        description: 'Regain confidence by dressing yourself without assistance.',
        color: '#10B981'
      },
      {
        icon: '😊',
        title: 'Boost Confidence',
        description: 'Stylish designs that make you look good and feel better.',
        color: '#F59E0B'
      },
      {
        icon: '🩺',
        title: 'Health Benefits',
        description: 'Reduce pain, prevent injuries, and improve overall wellbeing.',
        color: '#EF4444'
      }
    ];

    const hcpSteps = [
      { number: 1, title: 'Get Assessed', desc: 'Contact My Aged Care for a free assessment to determine your HCP level.' },
      { number: 2, title: 'Choose Provider', desc: 'Select a home care provider to manage your package funds.' },
      { number: 3, title: 'Select Clothing', desc: 'Browse our adaptive clothing range and choose items that suit your needs.' },
      { number: 4, title: 'Submit Request', desc: 'Request an invoice through our simple form below.' },
      { number: 5, title: 'Receive & Enjoy', desc: 'Get your adaptive clothing delivered and enjoy renewed independence.' }
    ];

    const testimonials = [
      {
        quote: "The magnetic closures have changed my life. Dressing is no longer a painful chore.",
        author: "Margaret R.",
        role: "HCP Level 3 Recipient",
        rating: 5
      },
      {
        quote: "As an occupational therapist, I recommend The Shapes United to all my clients.",
        author: "Dr. Michael Chen",
        role: "Occupational Therapist",
        rating: 5
      },
      {
        quote: "My mother regained her confidence and independence. Thank you for your amazing service.",
        author: "Sarah Johnson",
        role: "Daughter & Carer",
        rating: 5
      }
    ];

    const faqs = [
      {
        question: "What is a Home Care Package (HCP)?",
        answer: "HCP is government-funded support for older Australians who need assistance to live independently at home. It covers services like personal care, nursing, therapy, and assistive products."
      },
      {
        question: "Is adaptive clothing covered by HCP?",
        answer: "Yes, adaptive clothing that supports independence and addresses mobility challenges is typically covered under HCP as an assistive product."
      },
      {
        question: "How do I get assessed for HCP?",
        answer: "Call My Aged Care on 1800 200 422 or visit myagedcare.gov.au to request a free assessment by the Aged Care Assessment Team (ACAT)."
      },
      {
        question: "How long does delivery take?",
        answer: "We typically process and ship orders within 3-5 business days after receiving approval from your HCP manager."
      }
    ];

    return (
      <div className="older-adults">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-gradient"></div>
          <div className="container">
            <div className="hero-content">
              <div className="hero-badge">🏠 Home Care Packages</div>
              <h1>Adaptive Clothing for <span className="highlight">Older Australians</span></h1>
              <p className="subtitle">
                Support independence, dignity, and style through your Home Care Package. 
                Specially designed clothing for those with mobility challenges.
              </p>
              <div className="hero-stats">
                <div className="stat">
                  <div className="number">{stats.independence}%</div>
                  <div className="label">Increased Independence</div>
                </div>
                <div className="stat">
                  <div className="number">{stats.painReduction}%</div>
                  <div className="label">Reduced Pain</div>
                </div>
                <div className="stat">
                  <div className="number">{stats.satisfaction}%</div>
                  <div className="label">Client Satisfaction</div>
                </div>
              </div>
              <div className="hero-buttons">
                <button 
                  className="btn-primary"
                  onClick={() => document.getElementById('invoice-section').scrollIntoView({ behavior: 'smooth' })}
                >
                  Request HCP Invoice
                </button>
                <button className="btn-secondary">
                  Learn About HCP
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Problem Solution */}
        <section className="section problem-solution">
          <div className="container">
            <div className="section-header">
              <span className="tag">The Challenge & Solution</span>
              <h2>Age Gracefully with Dignity</h2>
              <p>Don't let dressing difficulties limit your lifestyle or independence.</p>
            </div>
            <div className="problem-solution-grid">
              <div className="problem-card">
                <div className="card-icon">😣</div>
                <h3>The Daily Struggle</h3>
                <ul>
                  <li>Painful joint movements</li>
                  <li>Difficulty with buttons & zippers</li>
                  <li>Limited range of motion</li>
                  <li>Loss of independence</li>
                  <li>Frustration & embarrassment</li>
                </ul>
              </div>
              <div className="arrow">→</div>
              <div className="solution-card">
                <div className="card-icon">✨</div>
                <h3>Our Adaptive Solution</h3>
                <ul>
                  <li>Magnetic closures</li>
                  <li>Open-back designs</li>
                  <li>Soft stretch fabrics</li>
                  <li>Easy dressing features</li>
                  <li>Stylish & comfortable</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="section benefits">
          <div className="container">
            <div className="section-header">
              <span className="tag">Why It Works</span>
              <h2>Transform Your Daily Routine</h2>
              <p>Experience the difference with purpose-designed adaptive clothing.</p>
            </div>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon" style={{ backgroundColor: `${benefit.color}20`, color: benefit.color }}>
                    {benefit.icon}
                  </div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* HCP Process */}
        <section className="section hcp-process">
          <div className="container">
            <div className="section-header">
              <span className="tag">Simple Process</span>
              <h2>How HCP Funding Works</h2>
              <p>Access adaptive clothing through your Home Care Package in 5 easy steps.</p>
            </div>
            <div className="process-timeline">
              {hcpSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.desc}</p>
                  </div>
                  {index < hcpSteps.length - 1 && <div className="step-connector"></div>}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Invoice Request Section */}
        <section id="invoice-section" className="section invoice">
          <div className="container">
            <div className="invoice-content">
              <div className="invoice-text">
                <span className="tag">Get Started</span>
                <h2>Request Your HCP Invoice</h2>
                <p className="lead">Complete this form and we'll prepare an invoice for your HCP manager. No commitment required.</p>
                
                <div className="invoice-features">
                  <div className="feature">
                    <div className="feature-icon">✓</div>
                    <div className="feature-text">
                      <h4>Free Consultation</h4>
                      <p>Personalized clothing recommendations</p>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">✓</div>
                    <div className="feature-text">
                      <h4>HCP Expertise</h4>
                      <p>We understand the funding process</p>
                    </div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">✓</div>
                    <div className="feature-text">
                      <h4>Fast Processing</h4>
                      <p>24-48 hour invoice preparation</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="invoice-form">
                <div className="form-card">
                  <h3>HCP Invoice Request Form</h3>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>Full Name *</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={this.handleInputChange}
                          placeholder="John Smith"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Email Address *</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={this.handleInputChange}
                          placeholder="john@example.com"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>HCP Level</label>
                        <select
                          name="hcpLevel"
                          value={formData.hcpLevel}
                          onChange={this.handleInputChange}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level 1 - Basic Care</option>
                          <option value="2">Level 2 - Low Care</option>
                          <option value="3">Level 3 - Intermediate</option>
                          <option value="4">Level 4 - High Care</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Provider Name</label>
                        <input
                          type="text"
                          name="provider"
                          value={formData.provider}
                          onChange={this.handleInputChange}
                          placeholder="Your care provider"
                        />
                      </div>
                    </div>
                    <div className="form-group full-width">
                      <label>Items of Interest *</label>
                      <textarea
                        name="items"
                        value={formData.items}
                        onChange={this.handleInputChange}
                        placeholder="Tell us what adaptive clothing items you're interested in..."
                        rows="3"
                        required
                      ></textarea>
                    </div>
                    <button type="submit" className="submit-btn">
                      Submit Request
                    </button>
                    <p className="form-note">
                      We'll prepare your invoice and contact you within 24 hours.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="section testimonials">
          <div className="container">
            <div className="section-header">
              <span className="tag">Success Stories</span>
              <h2>Loved by Older Australians</h2>
            </div>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">
                    {'★'.repeat(testimonial.rating)}
                  </div>
                  <p className="testimonial-quote">"{testimonial.quote}"</p>
                  <div className="testimonial-author">
                    <div className="author-name">{testimonial.author}</div>
                    <div className="author-role">{testimonial.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="section faq">
          <div className="container">
            <div className="section-header">
              <span className="tag">Need Help?</span>
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="faq-grid">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-card">
                  <h3>{faq.question}</h3>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="section contact-cta">
          <div className="container">
            <div className="contact-content">
              <h2>Need Personal Assistance?</h2>
              <p>Our HCP specialists are here to help you navigate the process.</p>
              <div className="contact-methods">
                <a href="tel:1300000000" className="contact-btn">
                  <span className="icon">📞</span>
                  <div>
                    <div className="method">Call Us</div>
                    <div className="detail">1300 000 000</div>
                  </div>
                </a>
                <a href="mailto:hcp@theshapesunited.com" className="contact-btn">
                  <span className="icon">✉️</span>
                  <div>
                    <div className="method">Email</div>
                    <div className="detail">hcp@theshapesunited.com</div>
                  </div>
                </a>
                <div className="contact-btn">
                  <span className="icon">🕒</span>
                  <div>
                    <div className="method">Hours</div>
                    <div className="detail">Mon-Fri 9am-5pm AEST</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default OlderAdults;